module.exports = __webpack_public_path__ + "static/img/10.a86dedf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/10.jpg
// module id = e3pb
// module chunks = 1